import { __assign } from '../../external/tslib/tslib.es6.mjs.js';
import { jsx } from 'react/jsx-runtime';
import $6Fm0V$react from 'react';
import ReactDOM from 'react-dom';

var PaymentIFrame = function (props) {
    var PaymentZoid = window.PaymentZoid;
    var PaymentZoidComponent = PaymentZoid.driver('react', {
        React: $6Fm0V$react,
        ReactDOM: ReactDOM,
    });
    return jsx(PaymentZoidComponent, __assign({}, props));
};

export { PaymentIFrame };
